import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import MenuMediumIllustration from '../../../assets/icons/menuMediumIllustration';
import Button from '../../../components/common/Button';
import CustomModal from '../../../components/common/CustomModal';

type Props = {
  isModalOpen: boolean;
  selectedCityName: string;
  setCity: () => void;
  setDefaultCity: () => void;
  setIsModalOpen: (b: boolean) => void;
};

const MenuConfigurationInBasketModal = ({
  isModalOpen,
  selectedCityName,
  setCity,
  setDefaultCity,
  setIsModalOpen,
}: Props) => {
  const handleOnClose = () => {
    setIsModalOpen(false);
    setDefaultCity();
  };

  return (
    <CustomModal
      className="custom-modal-another-catering"
      isOpen={isModalOpen}
      overlayClassName="overlay-form-fixed"
    >
      <div className="display-flex flex-direction-column height-100-per justify-content-space-between position-rel">
        <FontAwesomeIcon
          className="meal-modal__close font-size-18"
          icon={faTimes}
          onClick={handleOnClose}
        />
        <div className="text-align-center display-flex flex-direction-column align-items-center padding-top-80 padding-right-56 padding-bottom-80 padding-left-56">
          <MenuMediumIllustration />
          <p className="h400 spacer-top-24 spacer-bottom-16">
            Czy na pewno chcesz zmienić miasto?
          </p>
          <p className="body-l">
            W koszyku posiadasz dietę z konfiguracją menu ustawioną na miasto{' '}
            {selectedCityName}. Zmiana miasta spowoduje usunięcie diety z
            koszyka.
          </p>
        </div>
        <div className="custom-modal-another-catering__buttons justify-content-flex-end">
          <Button
            colorBlank
            containerClass="spacer-right-8"
            label="Anuluj"
            onClick={handleOnClose}
          />
          <Button
            label="Tak, zmień miasto"
            onClick={() => {
              setCity();
            }}
          />
        </div>
      </div>
    </CustomModal>
  );
};

export default MenuConfigurationInBasketModal;
